module.exports = __webpack_public_path__ + "img/black.8ded5804.webp";